import styles from "./VenuesBookItem.module.scss";
import React from "react";
import {useTranslation} from "react-i18next";
import useAppSelector from "../../../hooks/useAppSelector";
import {getVenueImage} from "../../../helpers/image.helper";
import moment from "moment";
import {IVenue} from "../../../models/Venue";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";
import {textCropping} from "../../../helpers/language.helper";

interface IVenuesBookItemProps {
    item: IVenue;
    clickOnButton: (id: number) => void;
    timeRange: {startDate: string, endDate: string} | null;
}

const VenuesBookItem: React.FC<IVenuesBookItemProps> = ({item, clickOnButton, timeRange}) => {

    const {t} = useTranslation();
    const {gymSettings} = useAppSelector(state => state.gymSettingsSlice);
    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    return (
        <div className={styles.item}>
            <div className={styles.image} style={{backgroundImage: `url(${getVenueImage(activeGym.endpoint, item.image)})`}}></div>
            <div className={styles.info}>
                <div className={styles.row}>
                    <h4 className={styles.name}>{item.name}</h4>
                    <p className={styles.price}>{gymSettings?.defaultCurrencyCode}{timeRange && item.price ? item.price : item.pricePerHour}</p>
                </div>
                <span className={styles.timeLabel}>{moment(timeRange?.startDate).format("DD MMM yyyy - HH:mm")} : {moment(timeRange?.endDate).format("HH:mm")}</span>
                <p className={styles.description}>{textCropping(item.description, 100)}</p>
                <div className={styles.btnWrapper}>
                    <CustomButton
                        text={t("AddToBasket")}
                        type={"button"}
                        typeStyle={"outline"}
                        blueForOutline={true}
                        borderRadius={true}
                        hoverToFillFromOutline={true}
                        functionOnClick={() => clickOnButton(item.id)}
                    />
                </div>
            </div>
        </div>
    )
}

export default VenuesBookItem;